export default __webpack_public_path__ + "static/media/SixtemaTinexta-338x132.798a8aa7.png";